<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>场次记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="学生/操作人ID">
              <Input v-model="queryParam.uid" placeholder="学生 uid，试做则为后台账号 ID"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="考试类型">
              <Select v-model="queryParam.examType" clearable placeholder="请选择考试类型">
                <Option value="PLACEMENT">入门测</Option>
                <Option value="SUMMATIVE">阶段测</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="场次状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择场次状态">
                <Option value="CREATED">已创建</Option>
                <Option value="IN_PROGRESS">答题中</Option>
                <Option value="PAUSED">已暂停</Option>
                <Option value="SCORING">评分中</Option>
                <Option value="READY">已交卷</Option>
                <Option value="COMPLETED">已完成</Option>
                <Option value="ABANDONED">已放弃</Option>
                <Option value="INCOMPLETE_REF">作答不足/待复核</Option>
                <Option value="INVALID">已作废</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="场次来源">
              <Select v-model="queryParam.source" clearable placeholder="请选择场次来源">
                <Option value="TRIAL">试做</Option>
                <Option value="STUDENT">学生考试</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/sessions/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <Modal v-model="reportVisible" :title="reportModalTitle" width="920" class-name="mex-rpt-modal">
      <div style="max-height: 78vh; overflow-y: auto">
        <MexSessionReport :report="report"></MexSessionReport>
      </div>
      <div slot="footer">
        <Button type="primary" @click="reportVisible = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="replayVisible" title="场次回放" width="1180">
      <p v-if="replay">场次 {{replay.session && replay.session.id}} / {{statusLabel(replay.session && replay.session.status, (replay.result && (replay.result.publishStatus || replay.result.flags)) || (replay.session && (replay.session.publishStatus || replay.session.flags)))}} / 定级 {{replay.session && replay.session.placementLevel || '—'}}</p>
      <p v-if="replay" class="mex-dim-hint">点左侧箭头可看原题、知识点和解析</p>
      <div v-if="replay" class="mex-replay-table-wrap">
        <Table :columns="itemColumns" :data="replay.replayItems || []" size="small"></Table>
      </div>
      <div v-if="replay && replay.result" class="mex-replay-result">
        <h4>成绩摘要</h4>
        <div class="mex-replay-hero">
          <p>
            <b>{{replay.result.title || '—'}}</b>
            · {{medalLabel(replay.result.medal)}}
            · 百分制 {{dash(replay.result.totalScore)}}
          </p>
          <p>
            定级 {{replay.result.placementLevel || '—'}}
            · 升班 {{promotionLabel(replay.result.promotion)}}
            · {{flagsLabel(replay.result.flags)}}
          </p>
        </div>
        <h4>模块分</h4>
        <Table :columns="moduleColumns" :data="moduleRows" size="small"></Table>
        <h4>雷达维度</h4>
        <div v-if="radarPlot" class="mex-radar-wrap">
          <svg class="mex-radar" viewBox="0 0 360 320">
            <polygon v-for="(ring, i) in radarPlot.rings" :key="'ring'+i" :points="ring" class="mex-radar-ring"></polygon>
            <line v-for="(ax, i) in radarPlot.axes" :key="'axis'+i" :x1="radarPlot.cx" :y1="radarPlot.cy" :x2="ax.x2" :y2="ax.y2" class="mex-radar-axis"></line>
            <polygon :points="radarPlot.polygon" class="mex-radar-area"></polygon>
            <circle v-for="(d, i) in radarPlot.dots" :key="'dot'+i" :cx="d.x" :cy="d.y" r="3.5" class="mex-radar-dot"></circle>
            <text v-for="(ax, i) in radarPlot.axes" :key="'lab'+i" :x="ax.lx" :y="ax.ly" text-anchor="middle" class="mex-radar-label">
              <tspan :x="ax.lx" dy="0">{{ax.label}}</tspan>
              <tspan :x="ax.lx" dy="14">{{ax.score}}</tspan>
            </text>
          </svg>
          <ul class="mex-radar-legend">
            <li v-for="row in radarRows" :key="row.label">
              <span>{{row.label}}</span>
              <b>{{row.score}}</b>
            </li>
          </ul>
        </div>
        <p v-else class="mex-dim-hint">暂无雷达数据</p>
        <p v-if="replay.result.benchmarkVisible === 1" style="margin-top: 8px">
          全国均分 {{dash(replay.result.nationalAvgScore)}} · 全国百分位 {{dash(replay.result.nationalPercentile)}}
          · 同城均分 {{dash(replay.result.cityAvgScore)}} · 同城百分位 {{dash(replay.result.cityPercentile)}}
          · 样本 {{dash(replay.result.benchmarkSampleN)}}
        </p>
        <p v-else class="mex-dim-hint">对标样本不足，全国/同城分数环不展示</p>
      </div>
      <p v-else-if="replay" class="mex-dim-hint" style="margin-top: 12px">暂无成绩（场次尚未出分）</p>
      <div slot="footer">
        <Button type="primary" @click="replayVisible = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="fullTextVisible" :title="fullTextTitle" width="560">
      <div style="word-break: break-all; white-space: pre-wrap; max-height: 360px; overflow: auto;">{{ fullText }}</div>
      <div slot="footer">
        <Button type="primary" @click="fullTextVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { questionTypeLabel, catReasonLabel, skillLabel } from './mex-question-type'
import { assetKind, assetUrl } from './mex-asset'
import MexSessionReport from './MexSessionReport'

export default {
  name: 'MexSessionList',
  components: { MexSessionReport },
  data () {
    return {
      searchLoading: false,
      reload: 0,
      replayVisible: false,
      replay: null,
      reportVisible: false,
      report: null,
      fullTextVisible: false,
      fullTextTitle: '',
      fullText: '',
      moduleColumns: [
        { title: '技能', key: 'label', width: 160 },
        { title: '百分制', key: 'score', width: 120 }
      ],
      itemColumns: [
        { type: 'expand', width: 50, render: (h, p) => this.renderExpand(h, p.row) },
        { title: '序', key: 'seq', width: 50, ellipsis: true },
        { title: '库', key: 'bank', width: 80, ellipsis: true, render: (h, p) => h('span', this.bankLabel(p.row.bank)) },
        { title: '业务键', key: 'businessCode', width: 180, ellipsis: true },
        { title: '题型', key: 'questionType', width: 340, render: (h, p) => h('span', questionTypeLabel(p.row.questionType, p.row.bank === 'SPEAK' ? 'Speaking' : p.row.skill)) },
        { title: '抽题', key: 'catReason', width: 90, ellipsis: true, render: (h, p) => h('span', catReasonLabel(p.row.catReason)) },
        { title: '学生作答', key: 'studentPayload', width: 220, ellipsis: true, render: (h, p) => this.renderFullTextCell(h, p.row.studentPayload, '学生作答') },
        { title: '标准答案', key: 'answerKey', width: 160, ellipsis: true, render: (h, p) => this.renderFullTextCell(h, p.row.answerKey, '标准答案') },
        { title: '得分', key: 'rawScore', width: 70, ellipsis: true },
        { title: '掌握', key: 'mastered', width: 60, ellipsis: true },
        { title: '跳过', key: 'skipped', width: 60, ellipsis: true },
        {
          title: '音频',
          key: 'audioUrl',
          width: 80,
          render: (h, params) => {
            let url = params.row.audioUrl
            if (!url) return h('span', '')
            return h('a', { attrs: { href: url, target: '_blank' } }, '打开')
          }
        }
      ],
      queryParam: {},
      tableColumns: [
        { title: 'ID', key: 'id', width: 80, ellipsis: true },
        { title: '来源', key: 'algoVersion', width: 80, ellipsis: true, render: (h, p) => h('span', p.row.algoVersion === 'TRIAL' ? '试做' : '学生') },
        { title: '学生/操作人', key: 'uid', width: 110, ellipsis: true },
        { title: '考试类型', key: 'examType', width: 100, ellipsis: true, render: (h, p) => h('span', p.row.examType === 'SUMMATIVE' ? '阶段测' : (p.row.examType === 'PLACEMENT' ? '入门测' : p.row.examType)) },
        { title: '创建时间', key: 'gmtCreate', width: 180, ellipsis: true },
        { title: '状态', key: 'status', width: 110, ellipsis: true, render: (h, p) => h('span', this.statusLabel(p.row.status, p.row.publishStatus || p.row.flags)) },
        { title: '定级', key: 'placementLevel', width: 90, ellipsis: true },
        { title: '题数', key: 'itemCount', width: 70, ellipsis: true },
        { title: '续考次数', key: 'reopenCount', width: 90, ellipsis: true },
        {
          title: '操作',
          key: 'action',
          width: 360,
          render: (h, params) => {
            let buttons = []
            if (params.row.status === 'READY' || params.row.status === 'INCOMPLETE_REF') {
              buttons.push(h('Button', {
                props: { type: 'success', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openReport(params.row.id) }
              }, '查看报告'))
            }
            buttons.push(h('Button', {
              props: { type: 'primary', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: () => this.openReplay(params.row.id) }
            }, '回放'))
            buttons.push(h('Button', {
              props: { type: 'error', size: 'small' },
              style: { marginRight: '6px' },
              on: { click: () => this.act(params.row.id, 'invalidate') }
            }, '作废'))
            buttons.push(h('Button', {
              props: { size: 'small' },
              on: { click: () => this.act(params.row.id, 'reopen') }
            }, '开启续考'))
            return h('div', { style: { whiteSpace: 'nowrap' } }, buttons)
          }
        }
      ]
    }
  },
  computed: {
    reportModalTitle () {
      if (this.report && this.report.examType === 'PLACEMENT') return '英语能力测评报告'
      if (this.report && this.report.examType === 'SUMMATIVE') return '成绩报告'
      return '测试报告'
    },
    moduleRows () {
      let obj = this.parseObj(this.replay && this.replay.result && this.replay.result.moduleJson)
      let keys = ['Listening', 'Speaking', 'Reading', 'Writing']
      let rows = []
      for (let i = 0; i < keys.length; i++) {
        let k = keys[i]
        if (obj[k] === undefined || obj[k] === null) continue
        rows.push({ label: skillLabel(k), score: obj[k] })
      }
      return rows
    },
    radarRows () {
      let obj = this.parseObj(this.replay && this.replay.result && this.replay.result.radarJson)
      let pairs = [
        ['listen', '听力'],
        ['speak', '口语'],
        ['read', '阅读'],
        ['write', '写作'],
        ['vocab', '词汇'],
        ['grammar', '语法']
      ]
      let rows = []
      for (let i = 0; i < pairs.length; i++) {
        let k = pairs[i][0]
        if (obj[k] === undefined || obj[k] === null) continue
        rows.push({ label: pairs[i][1], score: obj[k] })
      }
      return rows
    },
    radarPlot () {
      let rows = this.radarRows
      if (!rows.length) return null
      let cx = 180
      let cy = 158
      let r = 100
      let n = rows.length
      let pt = (i, ratio) => {
        let ang = -Math.PI / 2 + i * 2 * Math.PI / n
        return {
          x: +(cx + r * ratio * Math.cos(ang)).toFixed(1),
          y: +(cy + r * ratio * Math.sin(ang)).toFixed(1)
        }
      }
      let rings = []
      let levels = [0.2, 0.4, 0.6, 0.8, 1]
      for (let L = 0; L < levels.length; L++) {
        let pts = []
        for (let i = 0; i < n; i++) {
          let p = pt(i, levels[L])
          pts.push(p.x + ',' + p.y)
        }
        rings.push(pts.join(' '))
      }
      let axes = []
      let dots = []
      let poly = []
      for (let i = 0; i < n; i++) {
        let outer = pt(i, 1)
        let lab = pt(i, 1.32)
        let score = Number(rows[i].score)
        if (isNaN(score)) score = 0
        let ratio = Math.max(0, Math.min(100, score)) / 100
        let d = pt(i, ratio)
        poly.push(d.x + ',' + d.y)
        dots.push(d)
        axes.push({
          x2: outer.x,
          y2: outer.y,
          lx: lab.x,
          ly: lab.y,
          label: rows[i].label,
          score: score
        })
      }
      return { cx, cy, rings, axes, dots, polygon: poly.join(' ') }
    }
  },
  methods: {
    renderFullTextCell (h, raw, title) {
      let text = raw == null ? '' : String(raw)
      if (!text.trim()) return h('span', '—')
      if (text.length <= 24) return h('span', text)
      return h('a', {
        style: { whiteSpace: 'nowrap' },
        on: { click: () => this.showFullText(title, text) }
      }, text.slice(0, 24) + '...')
    },
    showFullText (title, text) {
      this.fullTextTitle = title
      this.fullText = text
      this.fullTextVisible = true
    },
    parseObj (raw) {
      if (!raw) return {}
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw) || {}
      } catch (e) {
        return {}
      }
    },
    dash (v) {
      if (v === undefined || v === null || v === '') return '—'
      return v
    },
    renderExpand (h, row) {
      let nodes = [
        this.kv(h, '原题', this.stemText(row)),
        this.kvMedia(h, '题干音频', row && row.stemAudio, row),
        this.kvMedia(h, '题干图', row && row.stemImage, row),
        this.kvMedia(h, '篇章图', row && row.passageImage, row),
        this.optionsBlock(h, row),
        this.kvMedia(h, '范文图', row && row.answerSampleImage, row),
        this.kvMedia(h, '示范音频', row && row.answerAudioSample, row),
        this.kv(h, '知识点', this.examPointText(row)),
        this.kv(h, '解析', (row && row.explanation) || '—')
      ]
      return h('div', { class: 'mex-replay-expand' }, nodes.filter(Boolean))
    },
    kv (h, label, text) {
      return h('div', { class: 'mex-replay-kv' }, [
        h('div', { class: 'mex-replay-k' }, label),
        h('div', { class: 'mex-replay-v' }, text)
      ])
    },
    kvMedia (h, label, path, row) {
      let node = this.mediaNode(h, path, row)
      if (!node) return null
      return h('div', { class: 'mex-replay-kv' }, [
        h('div', { class: 'mex-replay-k' }, label),
        node
      ])
    },
    mediaNode (h, path, row) {
      let skill = (row && (row.skill || (row.bank === 'SPEAK' ? 'Speaking' : ''))) || ''
      let url = assetUrl(path, skill)
      if (!url) return null
      let kind = assetKind(url)
      if (kind === 'image') {
        return h('img', { attrs: { src: url }, class: 'mex-replay-img' })
      }
      if (kind === 'audio') {
        return h('audio', { attrs: { src: url, controls: true }, class: 'mex-replay-audio' })
      }
      if (kind === 'video') {
        return h('video', { attrs: { src: url, controls: true }, class: 'mex-replay-video' })
      }
      return h('a', { attrs: { href: url, target: '_blank' } }, url)
    },
    optionsBlock (h, row) {
      let data = this.parseJsonValue(row && row.optionsJson)
      if (!data) return null
      if (Array.isArray(data) && data.length) {
        let items = data.map((o, idx) => {
          let code = (o && (o.code || o.key)) || String.fromCharCode(65 + idx)
          let text = (o && (o.text || o.label || o.value)) || ''
          let children = [h('div', String(code).toUpperCase() + '. ' + text)]
          let img = this.mediaNode(h, o && o.image, row)
          if (img) children.push(img)
          return h('div', { class: 'mex-replay-opt' }, children)
        })
        return h('div', { class: 'mex-replay-kv' }, [
          h('div', { class: 'mex-replay-k' }, '选项'),
          h('div', items)
        ])
      }
      if (data.tokens && data.tokens.length) {
        return this.kv(h, '选项', '可拖：' + data.tokens.join(' / '))
      }
      return null
    },
    stemText (row) {
      if (!row) return '—'
      let parts = []
      if (row.instructionCn) parts.push(row.instructionCn)
      if (row.instructionEn && row.instructionEn !== row.instructionCn) parts.push(row.instructionEn)
      if (row.script) parts.push(row.script)
      if (row.passageText) parts.push(row.passageText)
      if (row.stem) parts.push(row.stem)
      let blank = this.blanksText(row.blanksJson)
      if (blank) parts.push(blank)
      return parts.join('\n') || '—'
    },
    examPointText (row) {
      if (!row) return '—'
      let parts = []
      if (row.examPoint) parts.push(row.examPoint)
      if (row.knowledgePointHierarchy && row.knowledgePointHierarchy !== row.examPoint) {
        parts.push('路径：' + row.knowledgePointHierarchy)
      }
      return parts.join('\n') || '—'
    },
    blanksText (raw) {
      let data = this.parseJsonValue(raw)
      if (!Array.isArray(data) || !data.length) return ''
      return data.map((b, i) => {
        let no = (b && b.no) || (i + 1)
        let prompt = (b && b.prompt) || ''
        let ans = (b && (b.answer || b.key)) || ''
        return '空' + no + (prompt ? ' ' + prompt : '') + (ans ? ' → ' + ans : '')
      }).join('\n')
    },
    parseJsonValue (raw) {
      if (!raw) return null
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },
    medalLabel (code) {
      if (code === 'GOLD') return '金牌'
      if (code === 'SILVER') return '银牌'
      if (code === 'BRONZE') return '铜牌'
      return code || '—'
    },
    promotionLabel (code) {
      if (code === 'UP') return '直接升班'
      if (code === 'CONSOLIDATE') return '巩固后升'
      if (code === 'REMEDIATE') return '先补核心'
      if (code === 'REPEAT') return '本级重学'
      return '—'
    },
    flagsLabel (code) {
      if (code === 'TRIAL') return '试做'
      if (!code) return '学生考试'
      return code
    },
    bankLabel (code) {
      if (code === 'COMP') return '综合库'
      if (code === 'SPEAK') return '口语库'
      return code || '—'
    },
    statusLabel (code, publishOrFlags) {
      if (code === 'CREATED') return '已创建'
      if (code === 'CONSENT') return '待同意公约'
      if (code === 'PROFILE') return '信息采集'
      if (code === 'DEV_AUDIO') return '设备调试（音频）'
      if (code === 'DEV_MIC') return '设备调试（麦克风）'
      if (code === 'IN_PROGRESS') return '答题中'
      if (code === 'PAUSED') return '已暂停'
      if (code === 'SCORING') return '评分中'
      if (code === 'READY') return '已交卷'
      if (code === 'COMPLETED') return '已完成'
      if (code === 'ABANDONED') return '已放弃'
      if (code === 'INCOMPLETE_REF') {
        let pub = publishOrFlags || ''
        if (pub === 'REVIEW' || pub === 'PROVISIONAL' || pub === 'BELOW_L1') return '待复核'
        return '作答不足'
      }
      if (code === 'INVALID') return '已作废'
      return code || '—'
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    openReplay (id) {
      this.$http.post('/mex/sessions/detail', { id: id }).then(res => {
        if (res.status === 'ok') {
          this.replay = res.data
          this.replayVisible = true
        } else {
          this.$Message.error(res.msg || '回放失败')
        }
      })
    },
    openReport (id) {
      this.$http.post('/mex/sessions/report', { id: id }).then(res => {
        if (res.status === 'ok' && res.data) {
          this.report = res.data
          this.reportVisible = true
        } else {
          this.$Message.error((res && res.msg) || '暂无测试报告')
        }
      }).catch(() => {
        this.$Message.error('加载报告失败')
      })
    },
    act (id, action) {
      this.$http.post('/mex/sessions/' + action, { id: id }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-rpt-modal .ivu-modal-body {
  padding: 16px 0 0;
  background: #fef6ea;
}

.mex-replay-table-wrap {
  margin-top: 8px;
  overflow-x: auto;
}

.mex-replay-table-wrap .ivu-table-wrapper,
.mex-replay-table-wrap .ivu-table,
.mex-replay-table-wrap .ivu-table-body {
  overflow-x: auto;
}

.mex-replay-result {
  margin-top: 12px;
}

.mex-replay-result h4 {
  margin: 12px 0 8px;
}

.mex-replay-hero {
  padding: 12px;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}

.mex-dim-hint {
  color: #808695;
  font-size: 12px;
  line-height: 20px;
}

.mex-radar-wrap {
  display: flex;
  align-items: center;
  padding: 8px 12px 4px;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}

.mex-radar {
  width: 360px;
  height: 320px;
  flex-shrink: 0;
}

.mex-radar-ring {
  fill: none;
  stroke: #dce3ea;
  stroke-width: 1;
}

.mex-radar-axis {
  stroke: #dce3ea;
  stroke-width: 1;
}

.mex-radar-area {
  fill: rgba(45, 140, 240, 0.28);
  stroke: #2d8cf0;
  stroke-width: 2;
}

.mex-radar-dot {
  fill: #2d8cf0;
}

.mex-radar-label {
  fill: #515a6e;
  font-size: 12px;
}

.mex-radar-legend {
  list-style: none;
  margin: 0 0 0 24px;
  padding: 0;
  min-width: 140px;
}

.mex-radar-legend li {
  display: flex;
  justify-content: space-between;
  line-height: 28px;
  color: #515a6e;
}

.mex-radar-legend b {
  color: #17233d;
}

.mex-replay-kv {
  margin-bottom: 10px;
}

.mex-replay-k {
  font-weight: 600;
  color: #515a6e;
  margin-bottom: 4px;
}

.mex-replay-v {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 22px;
  color: #17233d;
}

.mex-replay-img {
  display: block;
  max-width: 280px;
  max-height: 180px;
  object-fit: contain;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
  margin-top: 4px;
}

.mex-replay-audio,
.mex-replay-video {
  display: block;
  width: 100%;
  max-width: 360px;
  margin-top: 4px;
}

.mex-replay-video {
  max-height: 200px;
}

.mex-replay-opt {
  margin-bottom: 8px;
  line-height: 22px;
  color: #17233d;
}
</style>



// WEBPACK FOOTER //
// MexSessionList.vue?948382f0